<template>
        <div class="product-video__wrapper">
            <div ref="CI_Video" class="product-video"></div>
        </div>
</template>
<script>
import { currency } from '@/lib'
import { mapGetters } from 'vuex'
export default {
    data(){
        return {
        }
    },
    mounted(){

        const benefitAmounts = ['BenefitAmount.Ben1', 'BenefitAmount.Ben2', 'BenefitAmount.Ben3', 'BenefitAmount.Ben4', 'BenefitAmount.Ben5', 'BenefitAmount.Ben6', 'BenefitAmount.Ben7', 'BenefitAmount.Ben8', 'BenefitAmount.Ben9', 'BenefitAmount.Ben10']
        const maxBenefit = benefitAmounts.map(benefitAmount => currency.format.number(this.product[benefitAmount])).sort((a, b) => b - a)[0]
        let blueRushVideoScript = document.createElement('script')
        blueRushVideoScript.setAttribute('src', 'https://d2ur3inljr7jwd.cloudfront.net/individeo/prod/edge/js/smartEmbed.js')
        blueRushVideoScript.setAttribute('data-iv-attachment-code', process.env.VUE_APP_BLUE_RUSH_ENV_CI)
        blueRushVideoScript.setAttribute('data-iv-lang', 'en-US')
        blueRushVideoScript.setAttribute('data-iv-use-branding', 'false')
        blueRushVideoScript.setAttribute('data-bp-enable-company-signature', 'false')
        blueRushVideoScript.setAttribute('data-bp-embed-smart-tracking', 'true')
        blueRushVideoScript.setAttribute('data-iv-individeo-data',  JSON.stringify({
            'Employer': this.employer.Name,
            'Broker_Name': this.agent.Name,
            'Benefit_Amount': maxBenefit,
            'CTA_Button': `${window.location.origin}/pdf/${this.$route.params.id}`
        }))
        this.$refs.CI_Video.appendChild(blueRushVideoScript)
    },
    computed: {
        ...mapGetters({
            proposalId: 'getProposalId',
            product: 'getCriticalIllness',
            employer: 'getEmployer',
            agent: 'getAgent'
        })    
    },
    methods: {
    }
}
</script>
<style lang="scss" scoped>
.product-video__wrapper {
    position: relative;
    width: 100%;
		padding-bottom: calc(56.25% - 6px);
		border: 5px solid $gray;
		background: #ffffff;
}
.product-video {
    height: 0;
    width: 100%;

}
</style>
